import { Component, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ApService } from 'src/app/shared/services/ap.service';

@Component({
  selector: 'app-device-all-alert',
  templateUrl: './device-all-alert.component.html',
  styleUrls: ['./device-all-alert.component.scss']
})
export class DeviceAllAlertComponent implements OnInit {
  currentPage = 1;
  page = 0;
  pageSize = 50;
  length = 0;
   pageEvent: PageEvent;
 
  pageSizeOptions = [10, 25, 50];

  loading = false;

  displayedColumns: string[] = [
    'Timestamp',
    'Type',
    'State',
    'Details'
  ];

  _dataSource = new MatTableDataSource<any>([]);

  selectedRange:
    | '4h'
    | '24h'
    | '7d'
    | 'thisMonth'
    | 'lastMonth' = '4h';

  private _device: any;
  @Input() selfSort: any;
  @Input()
  set deviceInfo(obj: any) {
    if (obj) {
      this._device = obj[0];
      this.loadData();
    }
  }

  constructor(private apService: ApService) {}

  ngOnInit(): void {
    this.loadData();
  }

  /* ============================================
   RANGE TABS
  ============================================ */

  selectedTabChange(event: MatTabChangeEvent): void {

    const label = event.tab.textLabel;

    switch (label) {
      case 'Last 4 Hrs':
        this.selectedRange = '4h';
        break;

      case 'Last 24 Hrs':
        this.selectedRange = '24h';
        break;

      case 'Last 7 Days':
        this.selectedRange = '7d';
        break;

      case 'This Month':
        this.selectedRange = 'thisMonth';
        break;

      case 'Last Month':
        this.selectedRange = 'lastMonth';
        break;
    }

    this.loadData();
  }

  /* ============================================
   PAGINATOR
  ============================================ */

  handlePageEvent(event: PageEvent): void {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.pageSize = event.pageSize;

    this.loadData();
  }

  /* ============================================
   LOAD DATA
  ============================================ */

  loadData(): void {

    if (!this._device?._id) return;

    this.loading = true;

    const params = {
      range: this.selectedRange,
      page: this.currentPage,
      limit: this.pageSize
    };

    this.apService
      .getAllAlerts(this._device._id, params)
      .subscribe({
        next: (res) => {

          const response = res?.data;

          this._dataSource.data = response?.data || [];
          this.length = response?.total || 0;
          this.pageSize = response?.limit || this.pageSize;
          this.loading = false;
        },

        error: () => {
          this.loading = false;
        }
      });
  }
}